import { Form, FormAnswer, PostSubmitConfig } from '../types'

/** Configuración por defecto: se conserva el comportamiento actual. */
export const DEFAULT_POST_SUBMIT: PostSubmitConfig = {
  action: 'gracias',
  whatsappAuto: false,
  whatsappLabel: 'Hablar por WhatsApp',
  whatsappMessage:
    'Hola, soy {{full_name}} de {{company}}. Acabo de completar el formulario y quiero recibir más información.',
  messageTitle: 'Solicitud enviada correctamente',
  messageText:
    'Hemos recibido tus datos y nos pondremos en contacto contigo.',
}

export function postSubmitConfig(form: Form): PostSubmitConfig {
  return { ...DEFAULT_POST_SUBMIT, ...(form.postSubmit ?? {}) }
}

/** Una URL externa solo se usa si es http(s) y se puede analizar. */
export function isValidUrl(url?: string): boolean {
  if (!url) return false
  try {
    const parsed = new URL(url.trim())
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
  } catch {
    return false
  }
}

/** wa.me exige solo dígitos: sin +, espacios, guiones ni paréntesis. */
export function whatsappDigits(raw?: string): string {
  return (raw ?? '').replace(/\D/g, '')
}

/**
 * Sustituye las variables del mensaje con los datos que acaba de dejar el
 * visitante. Las variables sin valor se eliminan en vez de quedar visibles.
 */
export function fillTemplate(
  template: string,
  contact: Record<string, string>,
  answers: FormAnswer[],
): string {
  const values: Record<string, string> = {
    full_name: contact.full_name ?? contact.name ?? '',
    company: contact.company ?? '',
    company_name: contact.company ?? '',
    phone: contact.phone ?? '',
    email: contact.email ?? '',
  }
  answers.forEach((answer) => {
    const value = Array.isArray(answer.value)
      ? answer.value.join(', ')
      : String(answer.value ?? '')
    values[answer.questionId] = value
    // Etiqueta normalizada, para poder escribir {{presupuesto_disponible}}.
    const key = answer.label
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_|_$/g, '')
    if (key) values[key] = value
  })
  return template
    .replace(/\{\{\s*([\w.]+)\s*\}\}/g, (_match, name: string) => values[name] ?? '')
    .replace(/\s{2,}/g, ' ')
    .trim()
}

/** Construye el enlace https://wa.me/NUMERO?text=MENSAJE_CODIFICADO */
export function whatsappLink(
  config: PostSubmitConfig,
  contact: Record<string, string>,
  answers: FormAnswer[],
): string | null {
  const number = whatsappDigits(config.whatsappNumber)
  if (!number) return null
  const text = fillTemplate(config.whatsappMessage ?? '', contact, answers)
  return text
    ? `https://wa.me/${number}?text=${encodeURIComponent(text)}`
    : `https://wa.me/${number}`
}
